import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "keepOnRecord",
      component: () => import("@/pages/keepOnIndex.vue")
    },{
      path: "/invite/:type/:id",
      name: "invite",
      component: () => import("@/pages/invite/invite.vue")
    },
    {
      path: "/inviteRegiste",
      name: "inviteRegiste",
      component: () => import("@/pages/invite/inviteRegiste.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/pages/login/index.vue")
    },
    {
      path: "/Datapanel",
      name: "Datapanel",
      component: () => import("@/pages/Datapanel/index.vue")
    },
    {
      path: "/quest",
      name: "quest",
      component: () => import("@/pages/quest/index.vue")
    },
    {
      path: "/healthLogin",
      name: "healthLogin",
      component: () => import("@/pages/healthLogin.vue")
    },
    {
      path: "/healthIndex",
      name: "healthIndex",
      component: () => import("@/pages/health/index.vue")
    },{
      path: "/starLogin",
      name: "starLogin",
      component: () => import("@/pages/starLogin.vue")
    },
    {
      path: "/starIndex",
      name: "starIndex",
      component: () => import("@/pages/star/index.vue")
    },
    {
      path: "/starReplayRecord",
      name: "starReplayRecord",
      component: () => import("@/pages/star/replayRecord.vue")
    },
    {
      path: "/poster",
      name: "poster",
      component: () => import("@/pages/poster.vue")
    },{
      path: "/magicLogin",
      name: "magicLogin",
      component: () => import("@/pages/magicLogin.vue")
    },
    {
      path: "/magicIndex",
      name: "magicIndex",
      component: () => import("@/pages/magic/index.vue")
    },{
      path: "/sendMessage",
      name: "sendMessage",
      component: () => import("@/pages/sendMessage.vue")
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js